// assets/dayNightSlider.js

let progressfader = {
  createNode: (html) => {
    const template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstChild;
  },

  init: () => {
    // Bind document-level events kun én gang
    if (!progressfader._docEventsBound) {
      progressfader._docEventsBound = true;

      // ✅ CAPTURE = true, så vi får events selvom controls stopper propagation
      document.addEventListener(
        "pointerup",
        (e) => {
          document
            .querySelectorAll(".progressfader .controls .slider1 .slider-handle.dragging")
            .forEach((h) => {
              h.classList.remove("dragging");
              try {
                if (h._dnPointerId != null) h.releasePointerCapture(h._dnPointerId);
              } catch (_) {}
              h._dnPointerId = null;
            });
        },
        { capture: true }
      );

      document.addEventListener(
        "pointermove",
        (e) => {
          const ctrlHandle = document.querySelector(
            ".progressfader .controls .slider1 .slider-handle.dragging"
          );
          if (!ctrlHandle) return;

          const pfNode = ctrlHandle.closest(".progressfader");

          const moveDelta = e.clientX - ctrlHandle.data.startDragMouseX;
          let newSelfX = ctrlHandle.data.startDragSelfX + moveDelta;

          const ctrlSlider = ctrlHandle.closest(".slider-track");
          const sliderWidth = ctrlSlider.getBoundingClientRect().width;
          const handleWidth = ctrlHandle.getBoundingClientRect().width;

          newSelfX = Math.max(0, newSelfX);
          newSelfX = Math.min(sliderWidth - handleWidth, newSelfX);

          ctrlHandle.style.left = newSelfX + "px";
          updateFader(pfNode);
        },
        { capture: true }
      );

      window.addEventListener("resize", () => updateAllFaders());
    }

    // Stop gallery/swiper swipe når man bruger slider controls (mobil)
    function preventGallerySwipe(pfNode) {
      const controls = pfNode.querySelector(".controls");
      if (!controls) return;

      if (controls.dataset.dnBound === "1") return;
      controls.dataset.dnBound = "1";

      const stop = (e) => {
        // Vi stopper propagation for touch-events så Swiper ikke swiper
        e.stopPropagation();
        // På iOS kan Swiper stadig tage swipe uden preventDefault
        // e.preventDefault();
      };

      // ✅ Kun touch-events her (ikke pointermove!), ellers dræber vi drag
      ["touchstart", "touchmove", "touchend"].forEach((ev) => {
        controls.addEventListener(ev, stop, { passive: false });
      });

      // pointerdown må gerne stoppe Swiper/clicks
      controls.addEventListener("pointerdown", (e) => e.stopPropagation(), { passive: true });
    }

    document.querySelectorAll(".progressfader:not(.initialized)").forEach((pfNode) => {
      pfNode.classList.add("initialized");

      const loader = progressfader.createNode("<div class='loaderoverlay'></div>");
      pfNode.prepend(loader);

      // Images
      if (!pfNode.querySelector(".images")) {
        let imageUrls = [];
        pfNode.querySelectorAll("*[data-url]").forEach((n) => imageUrls.push(n.getAttribute("data-url")));
        pfNode.querySelectorAll("*[data-url]").forEach((m) => m.remove());

        const imgs = progressfader.createNode("<div class='images'></div>");
        imageUrls.forEach((imgUrl) => {
          const img = progressfader.createNode(`<img src="${imgUrl}" />`);
          img.addEventListener("load", (e) => {
            e.currentTarget.classList.add("img-loaded");
            checkReadyState(pfNode);
          });
          imgs.appendChild(img);
        });
        pfNode.appendChild(imgs);
      }

      // Controls
      if (!pfNode.querySelector(".controls")) {
        pfNode.appendChild(
          progressfader.createNode(
            "<div class='controls'><div class='slider1'><div class='slider-track'><div class='slider-handle' draggable='false'></div></div></div></div>"
          )
        );
      }

      preventGallerySwipe(pfNode);

      // Hint
      if (pfNode.hasAttribute("data-hint")) {
        const hintText = pfNode.getAttribute("data-hint");
        if (hintText) pfNode.appendChild(progressfader.createNode(`<div class='hint'>${hintText}</div>`));
      }

      // Relpos
      const imgList = pfNode.querySelectorAll(".images img");
      imgList.forEach((imgNode, imgIndex) => {
        const rel = imgList.length > 1 ? imgIndex / (imgList.length - 1) : 0;
        imgNode.data = imgNode.data || {};
        imgNode.data.relpos = rel;
        imgNode.setAttribute("data-pos", rel);
      });

      const handle = pfNode.querySelector(".slider-handle");
      const track = pfNode.querySelector(".slider-track");

      // Handle drag
      handle.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        e.stopPropagation();

        handle.classList.add("dragging");
        handle.data = handle.data || {};
        handle.data.startDragMouseX = e.clientX;
        handle.data.startDragSelfX = parseFloat(handle.style.left) || 0;

        // ✅ Pointer capture gør drag stabilt
        handle._dnPointerId = e.pointerId;
        try {
          handle.setPointerCapture(e.pointerId);
        } catch (_) {}
      });

      // Track click/drag
      track.addEventListener("pointerdown", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const bounds = track.getBoundingClientRect();
        let x = e.clientX - bounds.left;

        const sliderWidth = bounds.width;
        const handleWidth = handle.getBoundingClientRect().width;

        x = Math.max(x, handleWidth / 2);
        x = Math.min(x, sliderWidth - handleWidth / 2);
        x -= handleWidth / 2;

        const size = sliderWidth - handleWidth;
        const rel = size > 0 ? x / size : 0;

        pfNode.data = pfNode.data || {};
        pfNode.data.relpos = rel;

        updateFaderControls(pfNode);
        updateFader(pfNode);

        // gør den drag-ready med det samme
        handle.classList.add("dragging");
        handle.data = handle.data || {};
        handle.data.startDragMouseX = e.clientX;
        handle.data.startDragSelfX = parseFloat(handle.style.left) || 0;

        handle._dnPointerId = e.pointerId;
        try {
          handle.setPointerCapture(e.pointerId);
        } catch (_) {}
      });

      updateFader(pfNode);
    });

    function checkReadyState(pfNode) {
      const isReady = pfNode.querySelectorAll(".images img:not(.img-loaded)").length === 0;
      if (!isReady) return;

      pfNode.classList.add("imagesloaded");

      setTimeout(() => {
        const loader = pfNode.querySelector(".loaderoverlay");
        if (loader) loader.remove();

        setTimeout(() => {
          pfNode.querySelectorAll(".hint").forEach((h) => h.classList.add("show"));
        }, 300);
      }, 400);
    }

    function updateFader(pfNode) {
      const now = Date.now();
      const last = pfNode.data?.lastcall || 0;
      if (now - last > 30) {
        updateFaderThrottled(pfNode);
        pfNode.data = pfNode.data || {};
        pfNode.data.lastcall = now;
      }
    }

    function updateFaderThrottled(pfNode) {
      pfNode.querySelectorAll(".hint").forEach((h) => h.classList.remove("show"));

      const ctrlSlider = pfNode.querySelector(".slider-track");
      const ctrlHandle = pfNode.querySelector(".slider-handle");

      const sliderRect = ctrlSlider.getBoundingClientRect();
      const handleRect = ctrlHandle.getBoundingClientRect();

      const denom = sliderRect.width - handleRect.width || 1;
      const relativePosition = (handleRect.left - sliderRect.left) / denom;

      let firstIx = 0;
      let lastIx = 1;
      let firstRelPos = 0;
      let lastRelPos = 0;

      const imgs = pfNode.querySelectorAll(".images img");

      imgs.forEach((imgNode, imgIndex) => {
        const relImgPos = imgNode.data.relpos;
        if (relativePosition > relImgPos) {
          firstIx = imgIndex;
          firstRelPos = relImgPos;
        }
      });

      lastIx = Math.min(firstIx + 1, imgs.length - 1);
      lastRelPos = imgs.item(lastIx).data.relpos;

      const span = lastRelPos - firstRelPos || 1;

      imgs.forEach((imgNode, imgIndex) => {
        let opacity = 0;
        if (imgIndex === firstIx) opacity = 1;
        else if (imgIndex === lastIx) {
          const diff = lastRelPos - relativePosition;
          opacity = 1 - diff / span;
        }
        imgNode.style.opacity = opacity;
      });

      pfNode.data = pfNode.data || {};
      pfNode.data.relpos = relativePosition;
    }

    function updateFaderControls(pfNode) {
      const p = pfNode.data?.relpos ?? 0;

      const ctrlSlider = pfNode.querySelector(".slider-track");
      const ctrlHandle = pfNode.querySelector(".slider-handle");

      const sliderWidth = ctrlSlider.getBoundingClientRect().width;
      const handleWidth = ctrlHandle.getBoundingClientRect().width;

      ctrlHandle.style.left = p * (sliderWidth - handleWidth) + "px";
    }

    function updateAllFaders() {
      document.querySelectorAll(".progressfader.initialized").forEach((pfNode) => {
        if (typeof pfNode.data?.relpos === "number") updateFaderControls(pfNode);
      });
    }
  },
};

// Kør init når DOM er klar + når Shopify loader sektioner
document.addEventListener("DOMContentLoaded", () => progressfader.init());
document.addEventListener("shopify:section:load", () => progressfader.init());
